import { render, staticRenderFns } from "./Nonogram.vue?vue&type=template&id=be9f94b8&"
import script from "./Nonogram.vue?vue&type=script&lang=js&"
export * from "./Nonogram.vue?vue&type=script&lang=js&"
import style0 from "./Nonogram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports